//#region IMPORT
import React, { useState, useRef } from 'react';
import { AI_BASIC } from './index';
import { useDispatch } from 'react-redux';
import useDelete from '../../../../hooks/useDeleteN';
import {
  useDelete1,
  useSave1,
  useSave2,
  useSearch1,
  useSearch2,
} from './AI_BASIC_QUERY';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import { AI_BASIC_Schema } from './AI_BASIC_Schema';
import { useSave } from '../../../../hooks/useSaveN';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { showLoading, closeLoading } from '../../../../Reducer/LoadingReducer';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { toPreviewSrc } from '../../../../util';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'Aicall';

export default function AI_BASICF() {
  //#region 변수
  const dispatch = useDispatch();

  //#region 그리드 변수
  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);

  const [rowData2, setRowData2] = useState([]); //그리드 데이터
  const [selectedRowData2, setSelectedRowData2] = useState([]);
  const [changedRowData2, setChangedRowData2] = useState([]);

  const gridRef1 = useRef(); // 보이스 체크 그리드
  const gridRef2 = useRef(); // 보이스 체크 현황 그리드
  //#endregion
  const [modalToggle1, setModalToggle1] = React.useState(false); //그리드 안 현장 설정하기 팝업 창
  const [voiceUrl, setVoiceUrl] = useState(null); //그리드 안 이름 설정하기 id값 저장
  //#endregion

  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.employeeNo,
    getKeyFromResult: (result) => result.employeeNo,
  });

  // 부서는 안전신문고(탭1)에서만 사용 → requireDep: false, autoFetchDep: true (탭1 전환 시 부서 목록 사용)
  const {
    handleCoChange,
    handleCustChange,
    validateSelection: validateSelectionBase,
  } = useCompanyCustDep({
    requireCompany: true,
    requireCust: true,
    autoFetchDep: true,
  });

  const validateSelection = () => {
    if (!validateSelectionBase()) return false;
    return true;
  };
  const delete1 = useDelete1();

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  //#region 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (processedRows) => {
      setRowData1(processedRows);
    },
  });
  const SearchLogic1 = async () => {
    setRowData1([]);
    ResetLogic();
    if (!validateSelection()) return;
    await Search1();
  };

  const { refetch: Search2 } = useSearch2({
    onSuccess: (processedRows) => {
      setRowData2(processedRows);
    },
  });
  // 녹음듣기
  const SearchLogic2 = async (_value1) => {
    const voicePath = _value1?.voiceAddress;
    if (!voicePath) {
      dispatch(
        showSnackbar({ message: '녹음 파일 경로가 없습니다.', type: 'warning' })
      );
      return;
    }
    const url = toPreviewSrc(voicePath);
    setVoiceUrl(url);
    setModalToggle1(true);
  };
  //#endregion
  //#region 저장
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();

  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '보이스 체크 내용',
    schema: { fields: AI_BASIC_Schema.fields.grid },
    getChangedRows: () => changedRowData1.filter((row) => !row.deleteYn),
    getDeletedRows: () => deletedRowData1,

    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: async (rows) => {
      const res1 = await Save1Async(rows);
      return res1;
    },
    reset: () => ResetLogic(),
    refresh: async () => {
      await Save2Async();

      SearchLogic1();
    },

    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  const SaveLogic1 = async () => {
    const gridApi = gridRef1.current.api;

    if (gridApi.isAnyFilterPresent()) {
      dispatch(
        showSnackbar({
          message: '필터가 적용되어 있는 상태에서는 저장할 수 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    const hasDelete = deletedRowData1.length > 0;
    const changedRows = changedRowData1.filter((row) => !row.deleteYn);
    const rowHasChange = changedRows.length > 0;

    if (!hasDelete && !rowHasChange) {
      dispatch(
        showSnackbar({
          message: '보이스 체크 내용을 입력해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    if (!rowHasChange && !hasDelete) {
      dispatch(showLoading());
      try {
        await Save2Async();

        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );

        SearchLogic1();
      } finally {
        dispatch(closeLoading());
      }

      return;
    }

    dispatch(showLoading());
    try {
      await Save1();
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion
  //#region 나머지 함수
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    setSelectedRowData1([rowData]);
  };
  const ResetLogic = () => {
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
  };

  const HandleAddClick = async (_gridRef) => {
    if (_gridRef) {
      const api = _gridRef.current.api;

      // const rowCount = api.paginationGetRowCount(); // 현재 행 개수 확인 (페이지)
      const rowCount = api.getDisplayedRowCount(); // 현재 행 개수 확인 (화면)
      const newNo = rowCount + 1;

      const newRow = {
        custCd: '', //사업장코드
        message: '', // 보이스 체크 내용
        no: newNo, //필수값
        newYn: 'Y', //필수값
      };
      _gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: newNo,
      });
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <AI_BASIC
        gridRef1={gridRef1}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        gridRef2={gridRef2}
        rowData2={rowData2}
        setRowData2={setRowData2}
        selectedRowData2={selectedRowData2}
        setSelectedRowData2={setSelectedRowData2}
        changedRowData2={changedRowData2}
        setChangedRowData2={setChangedRowData2}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        setVoiceUrl={setVoiceUrl}
        voiceUrl={voiceUrl}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        // 함수
        SearchLogic1={SearchLogic1}
        Search2={Search2}
        SearchLogic2={SearchLogic2}
        SaveLogic1={SaveLogic1}
        HandleAddClick={HandleAddClick}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
      />
    </div>
  );
}
